import gql from 'graphql-tag';

export const HOME_HERO_QUERY = gql`
  query HomeHero {
    user {
      id
      firstName
    }
  }
`;
